import { copyTextToClipboard } from "@/lib/clipboard";
import { isApplePlatform } from "@/lib/keyboard";

export function getCopyPageUrlShortcutKeys() {
  return [isApplePlatform() ? "Cmd" : "Ctrl", "Shift", "C"] as const;
}

export function getCopyPageUrlShortcutLabel() {
  return getCopyPageUrlShortcutKeys().join("+");
}

export function isCopyPageUrlShortcut(event: KeyboardEvent) {
  const hasPrimaryModifier = isApplePlatform() ? event.metaKey : event.ctrlKey;
  return hasPrimaryModifier && event.shiftKey && event.key.toLowerCase() === "c";
}

function getCurrentPageUrlForCopy() {
  const url = new URL(window.location.href);
  url.search = "";
  return url.toString();
}

export async function copyCurrentPageUrl() {
  return await copyTextToClipboard(getCurrentPageUrlForCopy(), {
    success: "Link copied",
    failure: "Could not copy link",
  });
}
